<template>
  <div>
    

    <div class="route-bar" style="padding-bottom: 10px;">
      <div v-if="showBreadcrumbs" class="route-bar-breadcrumb" style="padding-top: 10px; padding-bottom: 0px;">
        <ul>
          <li>
            <button class="p-link" @click="home">
              <i class="pi pi-home"></i>
            </button>
          </li>
          <li v-if="$route.path === '/'">/</li>
          <template v-for="(path, i) of $route.path.split('/')">
            <li :key="i" v-if="$route.path !== '/' && path === ''"></li>
            <!-- <li :key="i" v-else>{{ $route.path.split("/")[1] }}</li> -->
            <li 
              v-else 
              :key="i" 
              @click="pathClicked(path)" 
              class="anchorTag"
            >/ {{ path }}</li>
          </template>
        </ul>
      </div>
      <!-- <div class="route-bar-buttons">
        <Button @click="openNewOpportunity()" label="New Enquiry" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewContact()" label="New Contact" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewActivity()" label="New Activity" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewNote()" label="New Note" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
      </div> -->
    </div>

    <div class="container" style="padding-top:10px;" v-if="messages && messages.length">
      <div class="errorMsg">
        <span class="errorSpan pr-5">Some data was not loaded from different EPs.</span>
        <span class="errorSpan errorPointer pr-3" @click="viewAllErrors = true">View errors</span>
        <span class="errorSpan errorPointer" @click="clearAllErrors()">Clear messages</span>
      </div>
      <!-- <Message 
        v-for="(msg, index) of messages" 
        :key="index"
        :severity="msg.severity" 
        :life="msg.life"
        :closable="true"
      >{{msg.content}}</Message> -->
    </div>

    <ErrorsMessageDialog
      :viewDialog="viewAllErrors"
      :messages="messages"
      @close="viewAllErrors = false"
      @clearAllErrors="viewAllErrors = false; clearAllErrors()"
    />

    <Dialog v-if="enquirySuccess" header="Success" :visible.sync="enquirySuccess" :style="{width: '500px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>A new enquiry was saved successfully. The sQuote No is {{enquirySQuoteNo}}</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="enquirySuccess = false" class="p-button-text" autofocus />
        <Button
          @click="enquirySuccess = false; newQuote(enquiry)"
          label="Book In"
        />
      </template>
    </Dialog>

    <!-- Dialog to Create & Edit an enquiry -->
    <OpportunityForm
      :key="enquiryFormKey"
      v-if="enquiryDialog"
      :onlyUserBranch="onlyUserBranch"
      :opportunityDialog="enquiryDialog"
      :opportunityToEdit='enquiryToEdit'
      :disabledArray="enquiryDisabledArray"
      :colSelectedFieldsForTable="enquiryColsSelectedFieldsForTable"
      @close="enquiryDialog = false"
      @save="savedOpportunity"
    />

    <deplicateTable
      v-if="enquiryColsSelectedFieldsForTable"
      :duplicateDialog="enquiryDuplicateMessage"
      :colSelectedFieldsForTable="enquiryColsSelectedFieldsForTable"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="enquiryDuplicates"
      :requesting="duplicateRequesting"
      @close="enquiryDuplicateMessage = false"
      @agree="enquirySendDuplicate()"
    />

    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactFormDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog="contactFormDialog = false"
      @submit-contact-form="savedContact"
    />

    <DuplicateDialog
      v-if="contactDuplicateDialog"
      :key="contactDuplicateDialogKey"
      :duplicateDialog="contactDuplicateDialog"
      :contact="contactDuplicateContact"
      @hide-duplicate-dialog="contactDuplicateDialog = false"
      @submit-duplicate-form="contactSaveDuplicate"
    />

    <ActivityForm
      v-if="activityDialog"
      :key="activityFormKey"
      :activityForm="activityDialog"
      :activityToEdit="activity"
      :disabledArr="[]"
      @close="activityDialog = false"
      @saved="savedActivity"
    />

    <NoteForm
      v-if="noteDialog"
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="[]"
      @close="noteDialog = false"
      @noteSaved="noteSaved"
    />

    <QuotationForm
      :quotationDialog="quotationDialog"
      :opportunity="opportunity"
      :active="activeQuote"
      :quoteToEdit="quotation"
      :disabledArr="disabledArray"
      @close="quotationDialog = false"
      @saved="saved"
    />
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import OpportunityService from "@/service/OpportunityService";
import FiltersService from "@/service/FiltersSerice";

import OpportunityForm from './mbp/universalComponents/opportunity/OpportunityForm'
import deplicateTable from './mbp/universalComponents/opportunity/duplicateDialog'
import ContactForm from './mbp/universalComponents/contact/contactForm'
import DuplicateDialog from './mbp/universalComponents/contact/duplicateDialog'
import ActivityForm from "./mbp/universalComponents/activity/ActivityForm.vue";
import NoteForm from './mbp/universalComponents/note/NoteForm'
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import ErrorsMessageDialog from './mbp/universalComponents/ErrorsMessageDialog'

export default {
  components: {
    OpportunityForm,
    deplicateTable,
    ContactForm,
    DuplicateDialog,
    ActivityForm,
    NoteForm,
    QuotationForm,
    ErrorsMessageDialog
  },
  data: () => ({
    filtersService: new FiltersService(),
    opportunityService: new OpportunityService(),
    customerService: new CustomerService(),
    enquiryDisabledArray: [],
    enquiryFormKey1: 0,
    enquiryDialog: false,
    enquiryToEdit: {},
    enquirySQuoteNo: '',
    enquiry: {},
    enquirySuccess: false,
    enquiryDuplicateMessage: false,
    enquirySelectedCustomer: {},
    enquiryDuplicates: [],
    enquiryColsSelectedFields: [],
    enquiryColsSelectedFieldsForTable: [],
    enquiryDBViewFields: [],
    enquiryDBViewId: 8,
    reloadContactForm: 0,
    contactToEdit: {},
    contactFormDialog: false,
    contactDuplicateDialog: false,
    contactDuplicateContact: {},
    contactDuplicateToSend: {},
    contactDisabledArr: [],
    contactDuplicateDialogKey1: 0,
    activity: {},
    activityDialog: false,
    activityFormKey1: 0,
    note: {},
    submitted: false,
    noteDialog: false,
    reloadNoteForm: 0, // this is not the key
    disabledArray: [],
    quotation: {},
    activeQuote: false,
    opportunity: {},
    quotationDialog: false,
    viewAllErrors: false,
    duplicateRequesting: false,
    onlyUserBranch: false
  }),
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    showBreadcrumbs() {
      return this.$route.path !== '/'
    },
    messages() {
      
      return this.$store.getters.getErrorMessages
    },
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    },
    contactDuplicateDialogKey: {
      set() {
        this.contactDuplicateDialogKey1++
      },
      get() {
        return 'contactDuplicateDialogKey-' + this.contactDuplicateDialogKey1.toString()
      }
    },
    enquiryFormKey: {
      set(val) {
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey' + this.enquiryFormKey1.toString()
      }
    }
  },
  mounted() {
    

    this.enquiryGetColumnSelection()
    this.enquiryGetDBViewFields()

  }, 
  watch: {
    quotationDialog(val) {
      // 
      if (val && this.opportunity && this.opportunity.customer && this.opportunity.customer.requireApproval === true) {
        this.quotationDialog = false

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000,
        })
      }
    },
    contactDuplicateDialog(val) {
      this.contactDuplicateDialogKey = this.contactDuplicateDialogKey1 + 1
    },
    contactFormDialog(val) {
      this.reloadContactForm++
    },
    enquiryColsSelectedFieldsForTable(val) {
      
    },
    enquiryDialog(val) {
      if (val) {
        this.enquiryFormKey = this.enquiryFormKey1 + 1
      }
    },
    enquiryDBViewFields(val) { // toggles between default view and user saved view
      
      if (this.enquiryColsSelectedFieldsForTable.length < 1) {
        this.enquiryColsSelectedFieldsForTable = val.filter(a => a.defView)
      }
      // this.enquiryColsSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    saved({ quote, file, params, active }) {
      
      this.activeQuote = false
      this.quotationDialog = false
      this.quotation = {};
    },
    newQuote(opportunity) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewQuotation');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new Quotation",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4 || permission.permissionLevel === 5) {
          this.opportunity = opportunity
          this.disabledArray = [
            'opportunity',
            'mbpBranch',
            'Customer'
          ]
          // this.quotation = { ...this.opportunity, opportunity: this.opportunity };
          this.activeQuote = true
          this.quotationDialog = true;
        } 
      }
    },
    home() {
      window.location = "/#/";
    },
    noteSaved() {
      this.noteDialog = false;
      this.note = {};
    },
    openNewNote() {
      this.note = {};
      this.noteDialog = true;
      this.reloadNoteForm++
    },
    savedActivity(activity) {
      
      this.activityDialog = false
    },
    openNewActivity() {
      this.activity = {}
      this.activityDialog = true;
    },
    contactSaveDuplicate() {
      this.contactDuplicateDialog = false

      this.customerService
        .saveDuplicateContactDB(this.contactDuplicateToSend)
        .then(response => {
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000,
            });
          }
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving customer",
            life: 5000,
          })
        })
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      this.contactToEdit = {}
      this.contactFormDialog = false
      if (duplicateToSend) {
        this.contactDuplicateToSend = duplicateToSend
        this.contactDuplicateContact = duplicateContact
        this.contactDuplicateDialog = true
      }
    },
    openNewContact() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewContact');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new contact",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
          this.contactToEdit = { country: 'UK' }
          this.contactToEdit.canEmail = true;
          this.contactToEdit.canCall = true;
          this.contactToEdit.canMail = true;
          this.contactToEdit.active = true;
          this.contactDisabledArr = ['country']
          this.contactFormDialog = true
        }
      }
    },
    enquiryGetDBViewFields() {
      this.filtersService
        .getDBViewFields(this.enquiryDBViewId)
        .then(data => {
          this.enquiryDBViewFields = data
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    enquiryGetColumnSelection() {
      this.filtersService
        .getColumnSelection(this.enquiryDBViewId)
        .then(data => {
          
          this.enquiryColsSelectedFields = data
          
          let a = []
          data.forEach(b => {
            // 
            let c = a.find(d => d.dbField === b.dbField.dbField)
            // 
            if (!a[b.colOrder - 1] && !c) {
              a[b.colOrder - 1] = { 
                ...b.dbField,
                defWidth: b.width
              }
            }
          })
          
          if (a.length) {
            this.enquiryColsSelectedFieldsForTable = a
          }
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    enquirySendDuplicate() {
      this.duplicateRequesting = true
      this.enquiry.custCode = this.enquirySelectedCustomer.custCode

      this.opportunityService
        .saveDuplicateOpportunity(this.enquiry)
        .then((response) => {
          this.duplicateRequesting = false
          this.enquiryDuplicateMessage = false
          
          this.enquiry = response.data;
          
          this.enquirySQuoteNo = this.enquiry.sQuoteNo
          this.enquirySuccess = true
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Enquiry Saved",
              detail: `new Enquiry was saved successfully, Quote No generated : ${this.enquiry.sQuoteNo}`,
              life: 5000,
            });
            this.enquiryDialog = false;
          }
        })
        .catch((e) => {
          this.duplicateRequesting = false
          this.enquiryDuplicateMessage = false
          

          if (e.response)                
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000,
            })
        })
    },
    savedOpportunity(e) {
      
      this.enquiry = e.opportunity
      this.enquirySelectedCustomer = e.customer
      if (e.duplicates && e.duplicates.length) {
        this.enquiryDuplicates = e.duplicates;
        this.enquiryDuplicateMessage = true
      } else {
        if (e.sQuoteNo) {
          this.enquirySQuoteNo = e.sQuoteNo
          this.enquirySuccess = true
        }
      }
    },
    openNewOpportunity() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewEnquiry');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.onlyUserBranch = false
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new record",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4) {
          this.onlyUserBranch = false
          this.enquiryToEdit = { 'country': 'UK' }
          this.enquiry = {};
          this.enquiryDisabledArray = ['Country']
          this.enquiryDialog = true;
        } 
        else if (permission.permissionLevel === 5) {
          this.onlyUserBranch = true
          this.enquiryToEdit = { 'country': 'UK' }
          this.enquiry = {};
          this.enquiryDisabledArray = ['Country']
          this.enquiryDialog = true;
        }
      }
    },
    clearAllErrors() {
      this.$store.dispatch('setErrorMessage', [])
    },
    pathClicked(path) {
      let route = this.$route.path
      if (isNaN(parseInt(path))) {
        this.$router.push(route.substr(0, route.indexOf(path) + path.length))
      } else {
        this.$router.push(route.substr(0, route.indexOf(path) + path.length) + '/detail')
      }
    }
  }
};
</script>

<style lang="scss">

.errorMsg {
  width: 100%;
  height: 30px;
  background-color: orangered;
  opacity: 60%;
  border-radius: 5px;
  text-align: center;
  color: white;
  
  @media (max-width: 430px) {
    margin-top: 55px;
  }
}

.errorSpan {
  line-height: 28px;
}

.errorPointer {
  cursor: pointer;
}

.errorPointer:hover {
  cursor: pointer;
  text-decoration: underline;
}

.route-bar-buttons {
  float:right; 
  padding-top: 5px; 
  padding-right: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

</style>